export const experiencesIconsMapping =  new Map([
    [1, '../../../../assets/img/icons/leisure.svg'],
    [2, '../../../../assets/img/icons/beach-sun.svg'],
    [3, '../../../../assets/img/icons/relax.svg'],
    [4, '../../../../assets/img/icons/family.svg'],
    [5, '../../../../assets/img/icons/budget-save-sun.svg'],
    [6, '../../../../assets/img/icons/luxury.svg'],
    [7, '../../../../assets/img/icons/local-gastronomy.svg'],
    [8, '../../../../assets/img/icons/local-culture.svg'],
    [9, '../../../../assets/img/icons/Experience-local-way-of-life.svg'],
    [10, '../../../../assets/img/icons/spa-wellness.svg'],
    [11, '../../../../assets/img/icons/Beauty-services.svg'],
    [12, '../../../../assets/img/icons/romance.svg'],
    [13, '../../../../assets/img/icons/wedding.svg'],
    [14, '../../../../assets/img/icons/anniversary.svg'],
    [15, '../../../../assets/img/icons/bussiness-travel.svg'],
    [16, '../../../../assets/img/icons/conference.svg'],
    [17, '../../../../assets/img/icons/exhibitions.svg'],
    [18, '../../../../assets/img/icons/nightlife.svg'],
    [19, '../../../../assets/img/icons/car-moto-hire.svg'],
    [20, '../../../../assets/img/icons/taxi.svg'],
    [21, '../../../../assets/img/icons/tours.svg'],
    [22, '../../../../assets/img/icons/water-sports.svg'],
    [23, '../../../../assets/img/icons/outdoor-activities.svg'],
    [24, '../../../../assets/img/icons/Archeological-sights.svg'],
    [25, '../../../../assets/img/icons/nature-parks.svg'],
    [26, '../../../../assets/img/icons/shopping.svg'],
    [27, '../../../../assets/img/icons/events-concerts.svg'],
    [28, '../../../../assets/img/icons/classes-workshops.svg'],
    [29, '../../../../assets/img/icons/agricultural-experience.svg'],
    [30, '../../../../assets/img/icons/casino-Gambling.svg'],
    [31, '../../../../assets/img/icons/Zoos-Aquariums.svg'],
    [32, '../../../../assets/img/icons/medical-tourism.svg'],
  ]);
